import { render, staticRenderFns } from "./EditTicket.vue?vue&type=template&id=606bfb20"
import script from "./EditTicket.vue?vue&type=script&lang=js"
export * from "./EditTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports